<template lang="pug">
    .form-group.location-search
        gmap-autocomplete.form-control(@place_changed="placeChanged" slot-ref-name="headerSearchInput" :select-first-on-enter="true" :options="placeSearchOptions")
            template(v-slot="slotProps")
                input.form-control(:value="address" aria-label="Search" aria-describedby="search" placeholder="Search city..." ref="headerSearchInput" v-bind="slotProps.attrs" v-on="slotProps.listeners")
        svg-icon.search-icon(icon-id="search")
        svg-icon.current-location-icon(icon-id="current-location" @click="setCurrentLocation")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import GmapAutocomplete from 'gmap-vue/dist/components/autocomplete-input'

export default {
    name: 'location-search',

    components: {
        GmapAutocomplete,
    },

    data() { return {
        placeSearchOptions: {
            types: ['(cities)'],
        },
    }},

    computed: {
        ...mapGetters(['authUser', 'authCheck']),

        address() {
            return this.$store.getters['Client/Lairdnd/address']
        },
    },

    methods: {
        ...mapActions({
            setAddress: 'Client/Lairdnd/setAddress',
        }),

        placeChanged(place) {
            this.setAddress(place.formatted_address)
            const slug = _.kebabCase(place.formatted_address)
            this.$router.push({ name: 'game-master-directory-page', params: { cityDashState: slug } })
        },

        async setCurrentLocation() {
            let location = await this.getCurrentPositionViaNavigator()

            if (!location) {
                location = await this.getCurrentPositionViaGeolocation()
            }

            const place = await this.getPlaceByLocation(location)

            if (place) {
                this.placeChanged(place)
            }
        },

        async getCurrentPositionViaNavigator() {
            return new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(
                    position => resolve({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    }),
                    () => resolve()
                )
            })
        },

        async getCurrentPositionViaGeolocation() {
            const url = `https://www.googleapis.com/geolocation/v1/geolocate?key=${window.addiesaas.lairdnd.google_maps_api_key}`

            const payload = JSON.stringify({
                considerIp: true
            })

            const options = {
                headers: {
                    'Content-Type': 'application/json',
                },
                transformRequest: (data, headers) => {
                    delete headers.common['X-Authorization']
                    delete headers.common['X-CSRF-TOKEN']
                    delete headers.common['X-Location']
                    delete headers.common['X-Requested-With']
                    return data
                }
            }

            const { data: { location } } = await axios.post(url, payload, options)

            return location
        },

        async getPlaceByLocation(location) {
            return new Promise((resolve, reject) => {
                const geocoder = new google.maps.Geocoder()

                const request = { location }

                geocoder.geocode(request, (results, status) => {
                    if (status == google.maps.GeocoderStatus.OK) {
                        const place = results.find(result => result.types.includes('locality') || result.types.includes('administrative_area_level_3'))
                        resolve(place)
                    } else {
                        resolve()
                    }
                })
            })
        },
    }
}
</script>
